import { render, staticRenderFns } from "./shortcutMenu.vue?vue&type=template&id=9ec52066&"
import script from "./shortcutMenu.vue?vue&type=script&lang=js&"
export * from "./shortcutMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/shortcutMenu/shortcutMenu.vue"
export default component.exports